




import { Component, Vue, Watch } from 'vue-property-decorator';
import cargoDescription from '@/views/inquiries/Details.vue';

//  gql
import fetchInquiryQuery from '@/graphql/queries/FetchInquiry.gql';
import InquiryFields from '@/graphql/fragments/InquiryFields.gql';

@Component({
  components: {
    cargoDescription
  },
  apollo: {
    inquiry: {
      query: fetchInquiryQuery,
      prefetch: true,
      variables() {
        return {
          inquiryArgs: {
            inquiryId: this.$route.params.id
          }
        };
      },
      update: data => data && data.inquiries && data.inquiries[0],
      fetchPolicy: 'cache-and-network'
    }
  }
})
export default class ShipmentOrderDetails extends Vue {
  @Watch('$store.state.Inquiry.action')
  private refresh(action: string) {
    if (action === 'update') {
      this.$apollo.queries.inquiry.refetch();
      this.$store.dispatch('Inquiry/setAction', '');
    }
  }
}
